const content: { [key: string]: any } = {
  downForMaintenance: 'Temporarily Down For Maintenance',
  checkBackSoon: 'This page is down for regular maintenance. Please check back soon.',
  something_went_wrong: 'Something went wrong.',
  sessionExpiredMsg: 'Your Session has Expired',
  signInAgain: 'Please sign in again.',
};

export default content;
